export default __webpack_public_path__ + "static/media/dercam_user_manual_v59.3c339105.pdf";